import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'blaze-ui/icons'
import { TimeOfDay, SimpleScheduleSelectorProps, CustomTime } from './types'
import PostTimesStyles from '../PostTimes.module.scss'
import { Field as BaseField } from 'components/Wizards/MobileWizards/Field/Field'
import { TimeOfDayWithInlinePicker } from './TimeOfDayWithInlinePicker'
import { observer } from 'mobx-react-lite'

export const SimpleScheduleSelector = observer(
  ({ value, onChange, onComplete, title = 'When do you want to post?' }: SimpleScheduleSelectorProps) => {
    const handleTimeOfDayChange = (timeOfDay: TimeOfDay, customTime?: CustomTime) => {
      onChange({
        timeOfDay,
        customTime,
      })
    }

    return (
      <>
        <MobileWizard.Content>
          <MobileWizard.Section>
            <MobileWizard.Title>{title}</MobileWizard.Title>
          </MobileWizard.Section>

          <BaseField label="Choose time of day to post at">
            <TimeOfDayWithInlinePicker
              value={value.timeOfDay}
              customTime={value.customTime}
              onChange={handleTimeOfDayChange}
              ariaLabel="Schedule Type"
              className={PostTimesStyles.radioGroup}
              radioOptionClassName={PostTimesStyles.radioOption}
              selectedClassName={PostTimesStyles.selected}
              radioLabelClassName={PostTimesStyles.radioLabel}
            />
          </BaseField>
        </MobileWizard.Content>

        <MobileWizard.ButtonFooter>
          <Button size="lg" variant="primary" endIcon={ArrowRight} fullWidth onPress={onComplete}>
            Continue
          </Button>
        </MobileWizard.ButtonFooter>
      </>
    )
  },
)
